import { stringLookup } from '@/utils/zodHelper';
import { z } from 'zod';

const FunctionalAreaTranslationSchema = z.object({
  id: z.number().optional(),
  name: z.string().max(200),
  language_code: stringLookup().or(z.string()),
  inlineIndex: z.number().optional(),
});

export const FunctionalAreaSchema = z.object({
  id: z.number().optional(),
  translations: z.array(FunctionalAreaTranslationSchema).optional(),
  order: z.number().optional(),
  is_active: z.boolean().optional(),
});

export type FunctionalAreaSchemaType = z.infer<typeof FunctionalAreaSchema>;
